<template>
  <a-layout class='index animated fadeIn'>
    <a-card class="m-t-10" :bordered='false'>
      <a-button size='small' @click="()=>{$router.go(-1)}">
        <LeftOutlined />返回
      </a-button>
      <span class="ml15 card_title"> {{query.type?query.type=='detail'?'':'修改':'添加'}}管理员</span>
    </a-card>
    <a-card :bordered='false'>
      <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-item ref="account" label="登陆账号" name="account" help="账号长度为6字符到12字符">
          <a-input v-model:value="form.account"  :disabled="query.type&&(query.type=='detail' || query.type=='edit')"/>
        </a-form-item>
        <a-form-item ref="username" label="用户姓名" name="username">
          <a-input v-model:value="form.username" :readonly="query.type&&query.type=='detail'" />
        </a-form-item>
          <a-form-item ref="phone" label="手机号" name="phone">
          <a-input v-model:value="form.phone" :readonly="query.type&&query.type=='detail'" />
        </a-form-item>
        <a-form-item ref="is_change_password" label="是否修改密码" name="is_change_password" v-if="query.type=='edit'">
          <a-radio-group v-model:value="form.is_change_password">
            <a-radio :value="0">否</a-radio>
            <a-radio :value="1">是</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item ref="password" label="用户密码" name="password" v-if="(!query.type&&query.type!='detail')||form.is_change_password==1">
          <a-input v-model:value="form.password" type="password"  />
        </a-form-item>
           <a-form-item ref="password_again" label="确认密码" name="password_again" v-if="!query.type&&query.type!='detail'" >
          <a-input v-model:value="form.password_again" type="password_again"  />
        </a-form-item>
        <a-form-item ref="role_id" label="用户权限" name="role_id"> 
          <a-select mode="multiple" :disabled="query.type&&query.type=='detail'"   v-model:value="form.role_id" style="width: 100%" placeholder="请选择">
            <a-select-option v-for="v in roles " :key='v.id' :value="v.id" :label="v.username">
              {{v.role_name}}
            </a-select-option>
          </a-select>
        </a-form-item>
          <!-- <a-form-item ref="wx_code" label="绑定二维码" name="wx_code" v-if="!query.type&&query.type!='detail'" help="扫描二维码获取微信验证码">
          <img :src="code" alt="" class='width-100'>
        </a-form-item>
           <a-form-item ref="wx_code" label="微信验证码" name="wx_code" v-if="!query.type&&query.type!='detail'">
          <a-input v-model:value="form.wx_code"  :readonly="query.type&&query.type=='detail'" />
        </a-form-item>
          <a-form-item ref="status" label="状态" name="status" >
            <a-radio-group v-model:value="form.status" >
              <a-radio :value="1">
                启用
              </a-radio>
              <a-radio :value="2">
                禁用
              </a-radio>
            </a-radio-group>
        </a-form-item> -->
        <a-form-item :wrapper-col="{ span: 8, offset: 2 }" v-if="query.type!=='detail'">
          <a-button type="primary" @click="onSubmit">
            保存
          </a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </a-layout>
</template>

<script>
import { LeftOutlined } from "@ant-design/icons-vue";
import { getRole, createAdmin,adminDetail,editAdmin,getAdminCode } from "@/api/system";
import { ref, onMounted, reactive, toRefs, inject } from "vue";
import { iscode } from "@/utils/app";
// 初始化默认筛选项数值
let defForm = {
  account: "",
  username: "",
  password: "",
  role_id: [],
  id:null,
  phone:"",
  address:"",
  wx_code:"",
  password_again:'',
  status:1,
  is_change_password:0
};
export default {
  components: {
    LeftOutlined,
  },
  setup() {
    //pass
    const form = ref({ ...defForm });
    const state = reactive({
      labelCol: { span: 2 },
      wrapperCol: { span: 8 },
      value: [],
      rules: {
        password_again:[
                {
            required: true,
            message: "请再次确认密码",
          },
        ],
        account: [
          {
            required: true,
            message: "请输入账号",
          },
        ],
        role_id: [
          {
            required: true,
            message: "请选择权限组",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
          },
        ],
         phone: [
          {
            required: true,
            message: "请输入手机号",
          },
        ],
        username: [
          {
            required: true,
            message: "请输入登陆账号",
          },
        ],
        wx_code:[
            {
            required: true,
            message: "请输入微信验证码",
          },
        ]
      },
      roles: [],
    });
    const $router=inject("$router")
    const $route=inject("$route")
    const $message = inject("$message");
    const _lodash = inject("_lodash");
    onMounted(async()=>{
      if(!_lodash.isEmpty($route.query)){
          // 获取详情
        let result =await adminDetail($route.query.id).then(res=>res.data.data).catch(error=>error)
        form.value=result;
        form.value.is_change_password = 0;
        form.value.role_id=String(result.role_id).split(',');
        form.value.role_id.forEach((v,k)=>{
          form.value.role_id[k]=Number(v)
        })
      }else{
        adminCode()
      }
      getRoles();
    })
    // 获取绑定二维码
    const code=ref()
    const adminCode=async()=>{
      let result=await getAdminCode().then(res=>res.data).catch(error=>error)
        code.value=result.data.url
    }
    // 获取权限组
    const getRoles = async () => {
      let result = await getRole().then((res) => res.data).catch((error) => error);
      state.roles = result.data;
    };

    const ruleForm = ref();
    const onSubmit = () => {
      ruleForm.value
        .validate()
        .then(async () => {
          let result;
          if($route.query.type!=='edit'){
             result = await createAdmin({ ...form.value,role_id:form.value.role_id.join(',')  }).then((res) => res.data).catch((error) => error);
          }else{
             result = await editAdmin({id:$route.query.id,...form.value,role_id:form.value.role_id.join(',') }).then((res) => res.data).catch((error) => error);
          }
          if (iscode(result, true)) {
              ruleForm.value.resetFields();
               $router.go(-1);
          }
        })
        .catch((error) => {
          $message.error("请完善表单");
        });
    };
    return {
      form,
      ...toRefs(state),
      ruleForm,
      onSubmit,
      query:$route.query,
      code,
    };
  },
};
</script>
